export const AI_SEND_PROMPT_REQUESTED = 'AI_SEND_PROMPT_REQUESTED';
export const AI_SEND_PROMPT_SUCCEED = 'AI_SEND_PROMPT_SUCCEED';
export const AI_SEND_PROMPT_FAILED = 'AI_SEND_PROMPT_FAILED';

export const AI_CHECK_HEALTH_SUMMARY_REQUESTED = 'AI_CHECK_HEALTH_SUMMARY_REQUESTED';
export const AI_CHECK_HEALTH_SUMMARY_SUCCEED = 'AI_CHECK_HEALTH_SUMMARY_SUCCEED';
export const AI_CHECK_HEALTH_SUMMARY_FAILED = 'AI_CHECK_HEALTH_SUMMARY_FAILED';

export const AI_DOCTOR_EVALUATE_REQUESTED = 'AI_DOCTOR_EVALUATE_REQUESTED';
export const AI_DOCTOR_EVALUATE_SUCCEED = 'AI_DOCTOR_EVALUATE_SUCCEED';
export const AI_DOCTOR_EVALUATE_FAILED = 'AI_DOCTOR_EVALUATE_FAILED';

export const AI_GET_EVALUATE_REQUESTED = 'AI_GET_EVALUATE_REQUESTED';
export const AI_GET_EVALUATE_SUCCEED = 'AI_GET_EVALUATE_SUCCEED';
export const AI_GET_EVALUATE_FAILED = 'AI_GET_EVALUATE_FAILED';
